import Swiper, { Navigation, EffectFade, Autoplay, Pagination } from 'swiper';
import 'swiper/swiper.min.css';

const swiper = new Swiper('.blog-hero__wrapper.not-single', {
    modules: [Navigation, Autoplay, EffectFade, Pagination],
    loop: true,
    spaceBetween: 0,
    speed: 1000,
    grabCursor: true,
    slidesPerView: 1,
    allowTouchMove: false,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    fadeEffect: { crossFade: true },
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
    },
});



// WEBPACK FOOTER //
// ./src/js/custom/blog-hero.es6